// convert array to object with key as name
export const convertArrayToObject = <T>(array: T[], key: keyof T) => {
  const initialValue = {};
  return array.reduce((obj, item) => {
    return {
      ...obj,
      [item[key] as string]: item,
    };
  }, initialValue);
};
